import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    alert("Message Sent Successfully!");

    console.log(formData);

    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  return (
    
    <div className="container-fluid bg-white py-5">
        
      <div className="container">
        
            <h2 className="text-center mb-2">Contact Us</h2>
        <div className="row">

          {/* Left Side */}
          <div className="col-lg-5 mb-4">

            <div className="d-flex flex-column justify-content-center bg-primary h-100 p-5">

              {/* Office */}
              <div className="d-inline-flex border border-secondary p-4 mb-4">
                <h1 className="flaticon-office font-weight-normal text-secondary m-0 mr-3"></h1>

                <div className="d-flex flex-column">
                  <h4 className="text-white">Our Office</h4>

                  <p className="m-0 text-white">
                    Gandhi Nagar, Utraula Bazar
                    Utraula, Balrampur – 271604
                    Uttar Pradesh, India
                  </p>
                </div>
              </div>

              {/* Email */}
              <div className="d-inline-flex border border-secondary p-4 mb-4">
                <h1 className="flaticon-email font-weight-normal text-secondary m-0 mr-3"></h1>

                <div className="d-flex flex-column">
                  <h4 className="text-white">Email</h4>

                  <p className="m-0 text-white">
                    ecigroupindia@gmail.com
                  </p>
                </div>
              </div>

              {/* Phone */}
              <div className="d-inline-flex border border-secondary p-4">
                <h1 className="flaticon-telephone font-weight-normal text-secondary m-0 mr-3"></h1>

                <div className="d-flex flex-column">
                  <h4 className="text-white">Call Us</h4>

                  <p className="m-0 text-white">
                   +91 78002 60986 , +91 98244 40003
                  </p>
                </div>
              </div>

            </div>
          </div>

          {/* Right Side Form */}
          <div className="col-lg-7">

            <div className="contact-form bg-light p-5">

              <form onSubmit={handleSubmit}>

                {/* Name */}
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    className="form-control p-4"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Email */}
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    className="form-control p-4"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Subject */}
                <div className="form-group">
                  <input
                    type="text"
                    name="subject"
                    className="form-control p-4"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Message */}
                <div className="form-group">
                  <textarea
                    name="message"
                    rows="6"
                    className="form-control p-4"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                {/* Button */}
                <button
                  className="btn btn-primary py-3 px-5"
                  type="submit"
                >
                  Send Message
                </button>

              </form>

            </div>
          </div>

        </div>
      </div>
      {/* Google Map */}
    <div className="container-fluid px-0 mt-2">
  <iframe
    title="Google Map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2958.6125939679573!2d82.4171881245206!3d27.31956084248996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399742ed46747dd3%3A0x74d66b133ce9c32e!2sGandhi%20Nagar%2C%20Utraula%2C%20Uttar%20Pradesh%20271604!5e1!3m2!1sen!2sin!4v1779761298989!5m2!1sen!2sin"
    width="100%"
    height="450"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
    </div>
    </div>
    
  );
};

export default Contact;